// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader_loading-animation-modal-wrapper-plan__oqtg2 .loader_open__\\+P4Lj {
  height: 500px;
  text-align: center;
  padding-top: 240px;
  display: block;
}

.loader_loading-animation-modal-wrapper-plan__oqtg2 .loader_closed__gm7S8 {
  display: none;
}

.loader_main-green-nav__TNIkP.loader_fixed__3mGNh {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
}

.loader_loading-animation-modal-wrapper__CTr0s #loader_LoadingAnimationModal__8\\+wer {
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  z-index: 9999;
}

.loader_position-relative__uOYaC .loader_loading-animation-modal-wrapper__CTr0s #loader_LoadingAnimationModal__8\\+wer {
  position: absolute;
}

.loader_loading-animation-modal-wrapper__CTr0s #loader_LoadingAnimationModal__8\\+wer.loader_closed__gm7S8 {
  display: none;
}

.loader_loading-animation-modal-wrapper__CTr0s #loader_LoadingAnimationModal__8\\+wer.loader_open__\\+P4Lj {
  display: flex;
}

.loader_loading-animation-modal-wrapper__CTr0s #loader_LoadingAnimationModal__8\\+wer > .loader_content__CyfPt {
  display: flex;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/loader.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AACA;EACE,aAAA;AAEF;;AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAGF;;AADA;EACE,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;AAIF;;AAAA;EACE,kBAAA;AAGF;;AAAA;EACE,aAAA;AAGF;;AADA;EACE,aAAA;AAIF;;AAFA;EACE,aAAA;EACA,cAAA;AAKF","sourcesContent":[".loading-animation-modal-wrapper-plan .open {\n  height: 500px;\n  text-align: center;\n  padding-top: 240px;\n  display: block;\n}\n.loading-animation-modal-wrapper-plan .closed {\n  display: none;\n}\n.main-green-nav.fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 99;\n}\n.loading-animation-modal-wrapper #LoadingAnimationModal {\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  top: 0;\n  left:0;\n  z-index: 9999;\n}\n\n// When inside a positioned container (like modal), use absolute positioning\n.position-relative .loading-animation-modal-wrapper #LoadingAnimationModal {\n  position: absolute;\n}\n\n.loading-animation-modal-wrapper #LoadingAnimationModal.closed {\n  display: none;\n}\n.loading-animation-modal-wrapper #LoadingAnimationModal.open {\n  display: flex;\n}\n.loading-animation-modal-wrapper #LoadingAnimationModal > .content {\n  display: flex;\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading-animation-modal-wrapper-plan": `loader_loading-animation-modal-wrapper-plan__oqtg2`,
	"open": `loader_open__+P4Lj`,
	"closed": `loader_closed__gm7S8`,
	"main-green-nav": `loader_main-green-nav__TNIkP`,
	"fixed": `loader_fixed__3mGNh`,
	"loading-animation-modal-wrapper": `loader_loading-animation-modal-wrapper__CTr0s`,
	"LoadingAnimationModal": `loader_LoadingAnimationModal__8+wer`,
	"position-relative": `loader_position-relative__uOYaC`,
	"content": `loader_content__CyfPt`
};
export default ___CSS_LOADER_EXPORT___;
